import React from 'react'
import { AchSale } from './achSale'

export const AchSaleAPI = () => {
  return (
    <AchSale />
  )
}
